<template>
    <div>
        <page-header :header-title="` `" :header_logo="true" :header_side="true">
            <div slot="headerBtns">
                <button class="h_search_btn" @click="$router.push('/search')"></button>
            </div>
        </page-header>
        <page-header class="sub_header"></page-header>
        <curation-write-component :curation-type="'curationWrite'" :itemKey="itemKey"></curation-write-component>
    </div>
</template>

<script>
import CurationWriteComponent from "@/components/curation/CurationWriteComponent";

export default {
    name: "CurationRequestDetail",
    mixins: [],
    components: {
        CurationWriteComponent,
    },
    inject: [],
    provide() {
        return{

        }
    },
    props: {
    },
    data() {
        return{
            itemKey: Number(this.$route.params.i_idx),
        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{

    },
    watch: {

    },
}
</script>

<style scoped>

</style>
